import React from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Controller } from "react-hook-form";
import { estados } from "../../../../../../Utils/estados";
import { estadosBuro } from "../../../../../../Utils/estados";
import { GenericInput } from '../../LeasingInfo/components/GenericInput'

export const Address = ({
    setPage,
    defaultVals,
    register,
    control,
    errors,
    setValue,
    handleAutoCompleteAddress,
    coloniesFiltered,
    trigger, // Recibir trigger como prop
    typePerson
}) => {

    return (
        <div className="InputsDiv">
            <div className={`TextContainer mt-4`}>
                Ingresa domicilio de la {typePerson === 2 ? "empresa" : "persona"}
                <br />
            </div>
            {/* <span className="TextContainer">Llena los datos del domicilio.</span> */}

            <div className="ResponsiveContainer mt-5">
                <section className="InputsSection">
                    <span>
                        <GenericInput
                            register={register}
                            name="zip"
                            placeholder="*Código postal"
                            maxLength={5}
                            tooltip="Código postal"
                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={true}
                            handleAutoCompleteAddress={handleAutoCompleteAddress}
                        />


                    </span>
                    <span>
                        <GenericInput
                            register={register}
                            name="address"
                            placeholder="*Calle y número exterior"
                            maxLength={50}
                            tooltip="Calle y número exterior"
                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={true}
                        />
                    </span>

                    <span>
                        <Controller
                            name="col"
                            control={control}
                            rules={{ required: 'ESTE CAMPO ES REQUERIDO' }}
                            render={({ field }) => (
                                <>
                                    <Dropdown
                                        {...field}
                                        options={coloniesFiltered}
                                        optionLabel="label"
                                        value={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.value);
                                            setValue('colonia', e.value?.colonia || e.value || '');
                                        }}
                                        placeholder="Colonia o población"
                                        className={`Dropdown ${errors.col ? 'p-invalid' : ''}`}
                                        style={{
                                            // borderColor: errors.col ? '#d9505e' : undefined,
                                            maxWidth: '300px',
                                        }}
                                        tooltip={errors.col?.message}
                                        tooltipOptions={{ position: 'top' }}
                                        filter
                                        filterBy="label"
                                    />
                                    {errors.col && (
                                        <small className="p-error" style={{ display: 'block', marginTop: '0.25rem' }}>
                                            {errors.col.message}
                                        </small>
                                    )}
                                </>
                            )}
                        />
                    </span>


                </section>

                <section className="InputsSection">
                    <span>
                        <Controller
                            name="estado"
                            control={control}
                            rules={{ required: 'ESTE CAMPO ES REQUERIDO' }}
                            defaultValue={defaultVals.estado}
                            render={({ field, fieldState }) => (
                                <>
                                    <Dropdown
                                        {...field}
                                        options={estadosBuro}
                                        value={field.value === "Estado de Mexico" ? "Mexico" : field.value}
                                        placeholder="Estado"
                                        className={`Dropdown ${fieldState.invalid ? 'p-invalid' : ''}`}
                                        style={{
                                            // borderColor: fieldState.invalid ? '#d9505e' : undefined,
                                        }}
                                        tooltip={fieldState.error?.message}
                                        tooltipOptions={{ position: 'top' }}
                                        onChange={(e) => {
                                            field.onChange(e.value);
                                            // No necesitamos trigger aquí, react-hook-form manejará la validación
                                        }}
                                    />
                                    {fieldState.invalid && (
                                        <small className="p-error" style={{ display: 'block', marginTop: '0.25rem' }}>
                                            {fieldState.error?.message}
                                        </small>
                                    )}
                                </>
                            )}
                        />
                    </span>

                    <span>
                        <GenericInput
                            register={register}
                            name="city"
                            placeholder="*Ciudad"
                            maxLength={50}
                            tooltip="Ciudad"
                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={true}
                        />
                    </span>

                    <span>
                        <GenericInput
                            register={register}
                            name="municipio"
                            placeholder="Delegación o municipio"
                            maxLength={50}
                            tooltip="Delegación o municipio"

                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={true}

                        />
                    </span>

                </section>
            </div>
        </div>
    );
};
